(function() {
  if (window.SoruStringByoCartBridgeLoaded) return;
  window.SoruStringByoCartBridgeLoaded = true;

  var articleVariantMap = {"5820-03-3":56667440939394,"5820-04-3":56667441070466,"5820-05-3":56667440972162,"5820-06-3":56667441004930,"5820-07-3":56667440742786,"5820-12-3":56667440808322,"5820-14-3":56667440841090,"5820-19-3":56667440873858,"5830-03-3":56667441267074,"5830-04-3":56667441398146,"5830-05-3":56667441332610,"5830-06-3":56667441365378,"5830-07-3":56667441103234,"5830-12-3":56667441168770,"5830-14-3":56667441201538,"5830-19-3":56667441234306,"5847-12-1":56667444347266,"5847-69-1":56667444314498,"5858-03-1":56667444117890,"5858-04-1":56667444216194,"5858-05-1":56667444150658,"5858-06-1":56667444183426,"5858-07-1":56667443986818,"5858-12-1":56667444019586,"5858-14-1":56667444052354,"5858-19-1":56667444085122,"7820-03-3":56667441660290,"7820-04-3":56667441791362,"7820-05-3":56667441693058,"7820-06-3":56667441725826,"7820-07-3":56667441463682,"7820-12-3":56667441496450,"7820-14-3":56667441529218,"7820-19-3":56667441627522,"7830-03-3":56667441987970,"7830-04-3":56667442119042,"7830-05-3":56667442020738,"7830-06-3":56667442086274,"7830-07-3":56667441824130,"7830-12-3":56667441856898,"7830-14-3":56667441922434,"7830-19-3":56667441955202,"7858-03-1":56667443855746,"7858-04-1":56667443954050,"7858-05-1":56667443888514,"7858-06-1":56667443921282,"7858-07-1":56667443724674,"7858-12-1":56667443757442,"7858-14-1":56667443790210,"7858-19-1":56667443822978,"BS7830-12-1":56667445035394,"CD7820-03-1":56667445494146,"CD7820-04-1":56667445592450,"CD7820-05-1":56667445526914,"CD7820-06-1":56667445559682,"CD7820-07-1":56667445363074,"CD7820-12-1":56667445395842,"CD7820-14-1":56667445428610,"CD7820-19-1":56667445461378,"CD7830-03-1":56667445756290,"CD7830-04-1":56667445854594,"CD7830-05-1":56667445789058,"CD7830-06-1":56667445821826,"CD7830-07-1":56667445625218,"CD7830-12-1":56667445657986,"CD7830-14-1":56667445690754,"CD7830-19-1":56667445723522,"CF5830-03-1":56667446280578,"CF5830-04-1":56667446378882,"CF5830-05-1":56667446313346,"CF5830-06-1":56667446346114,"CF5830-07-1":56667446149506,"CF5830-12-1":56667446182274,"CF5830-14-1":56667446215042,"CF5830-19-1":56667446247810,"CF7830-03-1":56667446018434,"CF7830-04-1":56667446116738,"CF7830-05-1":56667446051202,"CF7830-06-1":56667446083970,"CF7830-07-1":56667445887362,"CF7830-12-1":56667445952898,"CF7830-14-1":56667445920130,"CF7830-19-1":56667445985666,"CL7832-03-1":56667447984514,"CL7832-05-1":56667448017282,"CL7832-12-1":56667447951746,"CM7820-12-1":56667445330306,"CSD5830-03-1":56667446542722,"CSD5830-04-1":56667446641026,"CSD5830-05-1":56667446575490,"CSD5830-06-1":56667446608258,"CSD5830-07-1":56667446411650,"CSD5830-12-1":56667446444418,"CSD5830-14-1":56667446477186,"CSD5830-19-1":56667446509954,"CT2830-04-1":56667448082818,"CT2830-05-1":56667448050050,"FBS7830-72-1":56667445068162,"FT7896-03-13":56667445166466,"FT7896-04-12":56667445264770,"FT7896-04-13":56667445297538,"FT7896-05-12":56667445199234,"FT7896-06-12":56667445232002,"FT7896-12-12":56667445100930,"FT7896-14-14":56667445133698,"LH5830-03-1":56667447329154,"LH5830-04-1":56667447427458,"LH5830-05-1":56667447361922,"LH5830-06-1":56667447394690,"LH5830-07-1":56667447198082,"LH5830-12-1":56667447230850,"LH5830-14-1":56667447263618,"LH5830-19-1":56667447296386,"LH7830-03-1":56667447820674,"LH7830-04-1":56667447918978,"LH7830-05-1":56667447853442,"LH7830-06-1":56667447886210,"LH7830-07-1":56667447689602,"LH7830-12-1":56667447722370,"LH7830-14-1":56667447755138,"LH7830-19-1":56667447787906,"MKS-10-5":56667449196930,"MSH5830-11-1":56667449590146,"MSH5830-12-1":56667443003778,"MSH5830-13-1":56667443134850,"MSH5830-14-1":56667443102082,"MSH5830-17-1":56667443200386,"MSH5830-19-1":56667443167618,"MSH7830-12-1":56667443233154,"MSH7830-13-1":56667443298690,"MSH7830-14-1":56667443265922,"MSH7830-17-1":56667443364226,"MSH7830-19-1":56667443331458,"MSK-10-5":56667449098626,"MSK-12-5":56667449000322,"MSK-13-5":56667449065858,"MSK-14-5":56667449033090,"MSK-17-5":56667449164162,"MSK-19-5":56667449131394,"MSL5820-12-1":56667442184578,"MSL5820-13-1":56667442250114,"MSL5820-14-1":56667442217346,"MSL5820-17-1":56667442348418,"MSL5820-19-1":56667442315650,"MSL5830-11-1":56667449557378,"MSL5830-12-1":56667442381186,"MSL5830-13-1":56667442479490,"MSL5830-14-1":56667442413954,"MSL5830-17-1":56667442545026,"MSL5830-19-1":56667442512258,"MSL7820-12-1":56667442577794,"MSL7820-13-1":56667442676098,"MSL7820-14-1":56667442643330,"MSL7820-17-1":56667442774402,"MSL7820-19-1":56667442708866,"MSL7830-12-1":56667442807170,"MSL7830-13-1":56667442872706,"MSL7830-14-1":56667442839938,"MSL7830-17-1":56667442971010,"MSL7830-19-1":56667442938242,"MSR30-12-1":56667448115586,"MSR30-14-1":56667448148354,"MSR58-12-1":56667448181122,"MSR58-13-1":56667448246658,"MSR58-14-1":56667448213890,"MSR58-17-1":56667448312194,"MSR58-19-1":56667448279426,"MSR78-12-1":56667448344962,"MSR78-13-1":56667448410498,"MSR78-14-1":56667448377730,"MSR78-17-1":56667448476034,"MSR78-19-1":56667448443266,"MSS5830-12-1":56667443396994,"MSS5830-13-1":56667443462530,"MSS5830-14-1":56667443429762,"MSS5830-17-1":56667443528066,"MSS5830-19-1":56667443495298,"MSS7830-12-1":56667443560834,"MSS7830-13-1":56667443626370,"MSS7830-14-1":56667443593602,"MSS7830-17-1":56667443691906,"MSS7830-19-1":56667443659138,"ORGMIX-13-3":56667449262466,"ORGMIX-14-3":56667449229698,"SBP-11-1":56667449655682,"SCB1930-50-2":56667448770946,"SCH-12-4":56667448836482,"SCH-13-4":56667448902018,"SCH-14-4":56667448869250,"SCH-17-4":56667448967554,"SCH-19-4":56667448934786,"SCU1930-50-2":56667448803714,"SF11530-12-1":56667439694210,"SF11530-12-2":56667439726978,"SF11530-13-1":56667439858050,"SF11530-13-2":56667439890818,"SF11530-14-1":56667439759746,"SF11530-14-2":56667439792514,"SF11530-17-1":56667440021890,"SF11530-17-2":56667440054658,"SF11530-18-1":56667439628674,"SF11530-18-2":56667439661442,"SF11530-19-1":56667439923586,"SF11530-19-2":56667439956354,"SF20030-12-1":56667440185730,"SF20030-12-2":56667440218498,"SF20030-13-1":56667440349570,"SF20030-13-2":56667440382338,"SF20030-14-1":56667440251266,"SF20030-14-2":56667440316802,"SF20030-17-1":56667440480642,"SF20030-17-2":56667440546178,"SF20030-18-1":56667440120194,"SF20030-18-2":56667440152962,"SF20030-19-1":56667440447874,"SF20030-19-2":56667440513410,"SF8530-11-1":56667449491842,"SF8530-11-2":56667449524610,"SF8530-12-1":56667439202690,"SF8530-12-2":56667439235458,"SF8530-13-1":56667439366530,"SF8530-13-2":56667439399298,"SF8530-14-1":56667439268226,"SF8530-14-2":56667439300994,"SF8530-17-1":56667439530370,"SF8530-17-2":56667439563138,"SF8530-18-1":56667439104386,"SF8530-18-2":56667439137154,"SF8530-19-1":56667439464834,"SF8530-19-2":56667439497602,"SFEXT4-12-2":56667449360770,"SFEXT4-13-2":56667449393538,"SHR20-12-2":56667448508802,"SHR20-13-2":56667448541570,"SHR20-19-2":56667448574338,"SHR30-12-2":56667448607106,"SHR30-13-2":56667448672642,"SHR30-14-2":56667448639874,"SHR30-17-2":56667448738178,"SHR30-19-2":56667448705410,"SM7830-12-1":56667444380034,"SM7830-13-1":56667444445570,"SM7830-14-1":56667444412802,"SM7830-17-1":56667444478338,"SMH-12-1":56667449295234,"SMH-13-1":56667449328002,"SPW5020-20-1":56667440578946,"SPW5020-20-2":56667440644482,"SPW5030-20-1":56667440677250,"SPW5030-20-2":56667440710018,"SU-11-1":56667449622914,"SVDH-10-2":56667449721218,"SVH-10-4":56667449688450,"SW5020-12-1":56667437236610,"SW5020-12-2":56667437269378,"SW5020-13-1":56667437433218,"SW5020-13-2":56667437465986,"SW5020-14-1":56667437302146,"SW5020-14-2":56667437400450,"SW5020-17-1":56667437597058,"SW5020-17-2":56667437629826,"SW5020-19-1":56667437498754,"SW5020-19-2":56667437564290,"SW5030-11-1":56667449426306,"SW5030-11-2":56667449459074,"SW5030-12-1":56667437760898,"SW5030-12-2":56667437793666,"SW5030-13-1":56667437924738,"SW5030-13-2":56667437990274,"SW5030-14-1":56667437826434,"SW5030-14-2":56667437891970,"SW5030-17-1":56667438121346,"SW5030-17-2":56667438154114,"SW5030-18-1":56667437662594,"SW5030-18-2":56667437728130,"SW5030-19-1":56667438023042,"SW5030-19-2":56667438055810,"SW7520-12-1":56667438186882,"SW7520-12-2":56667438219650,"SW7520-13-1":56667438350722,"SW7520-13-2":56667438383490,"SW7520-14-1":56667438252418,"SW7520-14-2":56667438317954,"SW7520-17-1":56667438547330,"SW7520-17-2":56667438580098,"SW7520-19-1":56667438416258,"SW7520-19-2":56667438481794,"SW7530-12-1":56667438711170,"SW7530-12-2":56667438743938,"SW7530-13-1":56667438875010,"SW7530-13-2":56667438907778,"SW7530-14-1":56667438776706,"SW7530-14-2":56667438809474,"SW7530-17-1":56667439038850,"SW7530-17-2":56667439071618,"SW7530-18-1":56667438612866,"SW7530-18-2":56667438678402,"SW7530-19-1":56667438940546,"SW7530-19-2":56667439006082,"VS5830-03-1":56667446804866,"VS5830-04-1":56667446903170,"VS5830-05-1":56667446837634,"VS5830-06-1":56667446870402,"VS5830-07-1":56667446673794,"VS5830-12-1":56667446706562,"VS5830-14-1":56667446739330,"VS5830-19-1":56667446772098,"VS7830-03-1":56667447067010,"VS7830-04-1":56667447165314,"VS7830-05-1":56667447099778,"VS7830-06-1":56667447132546,"VS7830-07-1":56667446935938,"VS7830-12-1":56667446968706,"VS7830-14-1":56667447001474,"VS7830-19-1":56667447034242,"WM5830-03-1":56667444642178,"WM5830-04-1":56667444740482,"WM5830-05-1":56667444674946,"WM5830-06-1":56667444707714,"WM5830-07-1":56667444511106,"WM5830-12-1":56667444543874,"WM5830-14-1":56667444576642,"WM5830-19-1":56667444609410,"WM7830-03-1":56667444904322,"WM7830-04-1":56667445002626,"WM7830-05-1":56667444937090,"WM7830-06-1":56667444969858,"WM7830-07-1":56667444773250,"WM7830-12-1":56667444806018,"WM7830-14-1":56667444838786,"WM7830-19-1":56667444871554};
  var targetOrigin = 'https://build-your-own.stringfurniture.com';
  var addingToCart = false;
  var latestDesign = null;
  var messageLog = [];

  function findIframe() {
    return document.querySelector('iframe[src*="build-your-own.stringfurniture.com"]');
  }

  function asPositiveQuantity(value) {
    var quantity = parseInt(value, 10);
    if (!Number.isFinite(quantity) || quantity < 1) return 1;
    return quantity;
  }

  function normalizeArticle(value) {
    return String(value || '').trim();
  }

  function rememberMessage(eventName, payload) {
    messageLog.push({
      event: eventName || '',
      at: new Date().toISOString(),
      keys: payload && typeof payload === 'object' ? Object.keys(payload) : []
    });

    if (messageLog.length > 30) {
      messageLog.shift();
    }
  }

  function unwrapPayload(raw) {
    if (!raw) return {};
    if (raw.data && typeof raw.data === 'object') return raw.data;
    return raw;
  }

  function extractSourceItems(payload) {
    var design = unwrapPayload(payload);

    if (Array.isArray(design)) return design;
    if (Array.isArray(design.items)) return design.items;
    if (Array.isArray(design.cart)) return design.cart;
    if (Array.isArray(design.articles)) return design.articles;
    if (design.design && Array.isArray(design.design.items)) return design.design.items;
    if (design.data && Array.isArray(design.data.items)) return design.data.items;

    return [];
  }

  function getArticleFromItem(item) {
    if (!item || typeof item !== 'object') return '';

    return normalizeArticle(
      item.article ||
      item.articleNumber ||
      item.articlenumber ||
      item.article_no ||
      item.articleNo ||
      item.sku ||
      item.SKU ||
      item.ean ||
      item.EAN ||
      item.id
    );
  }

  function getDesignName(design) {
    design = unwrapPayload(design);
    return design.name || design.designName || design.title || 'String Konfiguration';
  }

  function getDesignId(design) {
    design = unwrapPayload(design);
    return design.designid || design.designId || design.id || '';
  }

  function buildCartItems(design) {
    var sourceItems = extractSourceItems(design);
    var grouped = {};
    var missing = [];
    var designName = getDesignName(design);
    var designId = getDesignId(design);

    sourceItems.forEach(function(item) {
      var article = getArticleFromItem(item);
      if (!article) return;

      var variantId = articleVariantMap[article];
      if (!variantId) {
        if (missing.indexOf(article) === -1) missing.push(article);
        return;
      }

      if (!grouped[article]) {
        grouped[article] = {
          id: variantId,
          quantity: 0,
          properties: {
            'String Artikelnummer': article,
            'String Design': designName,
            'String Design ID': designId
          }
        };
      }

      grouped[article].quantity += asPositiveQuantity(item.quantity || item.qty || item.count);
    });

    return {
      items: Object.keys(grouped).map(function(article) { return grouped[article]; }),
      missing: missing
    };
  }

  function enableStringCart() {
    var iframe = findIframe();
    if (!iframe || !iframe.contentWindow) return;

    iframe.contentWindow.postMessage({ event: 'enableCart', data: {} }, targetOrigin);
    iframe.contentWindow.postMessage({ event: 'enableCart', data: {} }, '*');
  }

  function alertMissingArticles(missing) {
    window.alert(
      'Diese String-Artikel konnten noch nicht dem SORU-Warenkorb zugeordnet werden:\n\n' +
      missing.join(', ') +
      '\n\nBitte kontaktiere uns kurz, damit wir deine Konfiguration sauber pruefen koennen.'
    );
  }

  function addDesignToShopifyCart(design) {
    if (addingToCart) return;

    var activeDesign = design || latestDesign || {};
    var cartPayload = buildCartItems(activeDesign);

    if (cartPayload.items.length === 0 && latestDesign && latestDesign !== activeDesign) {
      activeDesign = latestDesign;
      cartPayload = buildCartItems(activeDesign);
    }

    if (cartPayload.missing.length > 0) {
      alertMissingArticles(cartPayload.missing);
      return;
    }

    if (cartPayload.items.length === 0) {
      window.alert('In dieser String-Konfiguration wurden keine Artikel zum Hinzufuegen gefunden. Bitte platziere zuerst mindestens ein String-Element im Planer.');
      return;
    }

    addingToCart = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: cartPayload.items })
    })
      .then(function(response) {
        if (!response.ok) return response.json().then(function(error) { throw error; });
        return response.json();
      })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function(error) {
        console.error('String BYO cart error', error);
        window.alert('Die String-Konfiguration konnte leider nicht automatisch in den Warenkorb gelegt werden. Bitte kontaktiere uns kurz, dann helfen wir dir direkt weiter.');
      })
      .finally(function() {
        addingToCart = false;
      });
  }

  window.addEventListener('message', function(event) {
    var iframe = findIframe();
    if (!iframe || event.source !== iframe.contentWindow) return;
    if (event.origin !== targetOrigin) return;
    if (!event.data || typeof event.data !== 'object') return;

    var eventName = event.data.event || event.data.type || '';
    var payload = unwrapPayload(event.data);
    rememberMessage(eventName, payload);

    if (eventName === 'byoLoaded') {
      enableStringCart();
      return;
    }

    if (eventName === 'designUpdate' || eventName === 'updateDesign') {
      latestDesign = payload;
      return;
    }

    if (eventName === 'cartUpdate' || eventName === 'updateCart') {
      addDesignToShopifyCart(payload);
    }
  }, true);

  window.setTimeout(enableStringCart, 500);
  window.setTimeout(enableStringCart, 2500);
  window.setTimeout(enableStringCart, 5000);

  window.SoruStringByoCart = {
    mapCount: Object.keys(articleVariantMap).length,
    testBuildCartItems: buildCartItems,
    addDesignToShopifyCart: addDesignToShopifyCart,
    getLatestDesign: function() { return latestDesign; },
    getMessageLog: function() { return messageLog.slice(); },
    enableStringCart: enableStringCart
  };
})();
